import React, { useState, useContext } from 'react';
import '../Customers/CustomersStyle.css';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import { ExcelRenderer } from 'react-excel-renderer';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import { ThemeContext } from '../Common/ThemeProvider';
import ProductFile from '../../Templates/Products.xlsx';

const ImportProducts = ({ hideImportproduct, SaveImportProductDetails, regionDetails }) => {

    const { CurrentTheme } = useContext(ThemeContext);
    const [ExcelImport, setExcelImport] = useState([]);

    const onImportFileAttach = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.name.slice(selectedFile.name.lastIndexOf('.') + 1) === "xlsx") {
            renderFile(selectedFile);
        }
    };

    const renderFile = (fileObj) => {
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                Alert.error("Error loading Excel", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
            else {
                setExcelImport(resp.rows);
            }
        });
    };

    const SaveProductDetails = () => {
        if (ValidateImport(ExcelImport)) {
            var productList = GetJsonProducts(ExcelImport);
            SaveImportProductDetails(productList);
        }
    };

    const ValidateImport = (ImportedProduct) => {
        var error = "";
        if (ImportedProduct.length <= 1) {
            error = "No Data Found.";
        }
        else if (ImportedProduct.length > 1) {
            for (var i = 1; i < ImportedProduct.length; i++) {
                if (ImportedProduct[i].length !== 7) {
                    error = "Row Mismatch Error";
                    break;
                }
                else {
                    var data = ImportedProduct[i];
                    for (var j = 0; j < data.length; j++) {
                        if (data[j] === undefined) {
                            error = "Column(s) Missing in Row : " + i;
                            break;
                        }
                    }
                    if (error === "" && data[2] !== undefined && data[4] !== undefined && data[6] !== undefined) {
                        // eslint-disable-next-line
                        var duplicateRows = 0;
                        for (var k = 0; k < ImportedProduct.length; k++) {
                            if (ImportedProduct[k][0].toString().trim().toUpperCase() ===
                                data[0].toString().trim().toUpperCase()) {
                                duplicateRows++;
                            }
                        }

                        if (data[0].toString().trim() === "") {
                            error = "Invalid Data Found in Row : " + i;
                            break;
                        }
                        if (duplicateRows > 1) {
                            error = "Duplicate Product Name found in Row " + i;
                            break;
                        }
                        else if (isNaN(data[2]) || isNaN(data[4]) || isNaN(data[6])) {
                            error = "Invalid Data Type Found in Row : " + i;
                            break;
                        }
                        else if (data[2] === 0 || data[4] === 0 || data[6] === 0) {
                            error = "Price/Margin/" + (regionDetails.TaxSystem !== undefined ? regionDetails.TaxSystem : "GST") + "cannot be Zero in Row : " + i;
                            break;
                        }
                    }
                    else {
                        break;
                    }
                }
            }
        }

        if (error !== "") {
            Alert.error(error, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }

        return (error === "") ? true : false;
    };

    const GetJsonProducts = (ImportedProduct) => {
        var ProductList = [];
        for (var i = 1; i < ImportedProduct.length; i++) {
            var data = ImportedProduct[i];
            const Product = {
                Name: data[0].toString().trim(),
                Description: data[1].toString().trim().toUpperCase() === "NULL" ? null : data[1].toString().trim(),
                Price: data[2],
                Units: data[3].toString().trim().toUpperCase() === "NULL" ? null : data[3].toString().trim(),
                Gst: data[4],
                HSNCode: data[5].toString().trim().toUpperCase() === "NULL" ? null : data[5].toString().trim(),
                Margin: data[6],
                IsDeleted: 0
            };

            ProductList.push(Product);
        }

        return ProductList;
    }

    return (
        <div>
            <div id="addProduct" className="modal" style={{ display: "block" }}>
                <div className="modal-content" style={{ width: "70%" }}>
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Import Product</span>
                        <span className="close" onClick={hideImportproduct}>&times;</span>
                    </div>
                    <div style={{ display: "flex" }}><input style={{ width: "80%" }} type="file" className="form-control"
                        name="ExcelImport"
                        onChange={onImportFileAttach} accept=".xlsx, .xls"></input>
                        <a style={{ paddingLeft: "5%", paddingTop: "5px" }} href={ProductFile} download="Products.xlsx">Template</a>
                    </div>
                    <div style={{ height: "50vh", overflow: "auto", marginTop: "10px" }}>
                        <table className="table table-striped">
                            <thead className="StickyHeader">
                                <tr>
                                    {ExcelImport.length > 0 && ExcelImport[0].map((row, index) => (
                                        <th key={index}>{row}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {ExcelImport.length > 1 && ExcelImport.map((row, index) => (
                                    index > 0 && (
                                        <tr key={index}>
                                            {row.map((data, index) => (
                                                <td key={index}>{data}</td>
                                            ))}
                                        </tr>
                                    )
                                ))}

                            </tbody>
                        </table>
                    </div>
                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                        <div>
                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SaveProductDetails}>Save</button>
                            <button type="button" onClick={hideImportproduct} className="btn btn-default">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImportProducts;